// extracted by mini-css-extract-plugin
export default {"container":"ScrollBackToTopBtn_container__Y6ZHW"};